export default __webpack_public_path__ + "static/media/logo_cliente.1ddd5161.png";